<template>
  <div class="popBox" :id="elId" v-if="had === 0">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    // 触发弹窗元素类名
    parentEl: {
      type: String,
      required: true,
    },
    offsetTop: {
      type: Number,
      default: 10,
    },
    offsetLeft: {
      type: Number,
      default: 10,
    },
    // 当前弹窗id,用于判断是否有重复
    elId: {},
    warpStyle: {
      type: Object,
    },
    timer: {
      type: Number,
      default: 3,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: 'bottom', // 弹出方向
    },
    onOff: {
      type: Boolean,
      default: null, // 关联开关
    },
    classall: {
      type: String, // 多组件class
    },
  },
  data() {
    return {
      had: 0,
      newParentEl: null,
    }
  },
  methods: {
    getParent(e) {
      const parent = e.parent()
      if (parent?.prop('className')?.includes(this.parentEl)) return e
      return this.getParent(e.parent())
    },
    calculate(e, el) {
      this.newParentEl = e.target
      let parentEl = this.getParent(this.$(e.target))
      let offset = parentEl.offset()
      let height = parentEl.outerHeight()
      let width = parentEl.outerWidth()
      if (this.position == 'left') {
        el.css({
          top: 0,
          left: (this.appendToBody === false ? 0 : offset.left) - width - this.offsetLeft + 'px',
        })
      } else {
        el.css({
          top: (this.appendToBody === false ? 0 : offset.top) + height + this.offsetTop + 'px',
          left: this.appendToBody === false ? 0 : offset.left + 'px',
        })
      }
    },
  },
  mounted() {
    this.had = this.$('body>#' + this.elId).length
    let el = this.$(this.$el)
    if (this.appendToBody !== false) {
      document.body.appendChild(this.$el)
    }
    if (this.parentEl) {
      this.$('.' + this.parentEl).click((e) => {
        if (this.classall) {
          this.$('.' + this.classall).css('display', 'none')
        }
        this.calculate(e, el)
        el.animate({ height: 'toggle', opacity: 'toggle' }, this.timer * 100)
      })
    }
    if (this.had === 0) {
      document.body.addEventListener(
        'click',
        (e) => {
          if (e.target === this.newParentEl) return
          this.$(this.$el).css('display', 'none')
        },
        false
      )
    }
  },
  watch: {
    onOff: {
      handler(newV) {
        const mb = document.body.clientWidth < 768
        if (mb) setTimeout(() => {
          this.$('body').css({ overflow: newV ? 'hidden' : '' })
        }, 200);
        if (!newV && newV !== null) {
          this.$('#' + this.elId).css('display', 'none')
        }
      },
      deep: true,
      immediate: false,
    },
  },
}
</script>
<style scoped lang='scss'>
.popBox {
  padding: 20px;
  background-color: white;
  box-shadow: 0 15px 30px rgb(0 0 0 / 10%);
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  z-index: 99;
  // transform: rotateX(180deg);
  // transform-origin: center -17px;
  // li {
  //   transform: rotateX(180deg);
  // }
}
</style>
